<template>
  <div class="species">
    <div class="species-banner">
      <div class="container">
        <h1 class="species-banner__title">Species</h1>
      </div>
    </div>
    <div class="species-body">
      <div class="container">
        <div class="species-panel">
          <h3 class="species-title">Brief introduction</h3>
          <p class="species-desc">
            Below you will find transcription factors and transcription
            regulatory ligands for 30 species in the genus Actinomycetes, click
            on the dots to view the information.
          </p>
          <div class="species-charts tree-chart">
            <tree-chart
              :data="treeData"
              @finished="handleTreeChartRendered"
            ></tree-chart>
          </div>
          <h3 class="species-title__third">Percentage of family members</h3>
          <p class="species-desc">
            Below you will find transcription factors and transcription
            regulatory ligands for 30 species in the genus Actinomycetes, click
            on the dots to view the information.
          </p>
          <div class="species-charts">
            <div class="species-charts__item flex-column">
              <h3 class="species-charts__title">TF</h3>
              <pie-chart
                :data="pieData[0]"
                @finished="handlePieChartRendered"
              ></pie-chart>
            </div>
            <!--<div class="species-charts__item flex-column">
              <h3 class="species-charts__title">TF_Cof</h3>
              <pie-chart
                :data="pieData[1]"
                @finished="handlePieChartRendered"
              ></pie-chart>
            </div>-->
          </div>
        </div>
        <div class="species-panel">
          <h3 class="species-title__second">Bouchesdurhonensis</h3>
          <span style="margin-right: 10px; font-size: 14px">Species:</span>
          <el-select
            v-model="speciesValue"
            placeholder="Select"
            @change="initBarData"
            style="width: 300px"
          >
            <el-option
              v-for="item in speciesOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div class="species-charts">
            <div class="species-charts__item">
              <div class="species-charts__item__chart">
                <bar-chart
                  :data="barData[0]"
                  :x-axis="xAxis[0]"
                  @finished="handleBarChartRendered"
                ></bar-chart>
                <h3 class="species-charts__title">TF</h3>
              </div>
              <!--<div class="species-charts__item__chart">
                <bar-chart
                  :data="barData[1]"
                  :x-axis="xAxis[1]"
                  @finished="handleBarChartRendered"
                ></bar-chart>
                <h3 class="species-charts__title">TF_Cof</h3>
              </div>-->
            </div>
            <div class="species-charts__item">
              <sunburst-chart :data="sunburstData"></sunburst-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TreeChart from "@/components/charts/TreeChart.vue";
import PieChart from "@/components/charts/PieChart.vue";
import BarChart from "@/components/charts/BarChart.vue";
import SunburstChart from "@/components/charts/SunburstChart.vue";
import { px2rem } from "@/utils/rem";
import {
  numericalValueByFamily,
  speciesWithNumericalValue,
  tfCountsByFamily,
  tfCountsBySpecies,
} from "@/api/species";
import { initList } from "@/api/search";

export default {
  name: "SpeciesView",
  components: {
    SunburstChart,
    BarChart,
    PieChart,
    TreeChart,
  },
  data() {
    return {
      activeName: "Species",
      treeData: [],
      pieData: [],
      barData: [
        [120, 200],
        [150, 100],
      ],
      sunburstData: [],
      xAxis: [],
      pieChartRenderedCount: 0,
      barChartRenderedCount: 0,
      speciesOption: [],
      speciesValue: "",
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.initTreeData();
      this.getSpeciesList();
    },
    getSpeciesList() {
      initList().then((res) => {
        this.speciesOption = res.data.species.map((item) => {
          return { value: item, label: item };
        });
        if (this.speciesOption.length > 0) {
          this.speciesValue = this.speciesOption[0].value;
        } else {
          this.speciesValue = "";
        }
      });
    },
    // 树状图渲染完成
    handleTreeChartRendered() {
      this.initPieData();
    },
    handlePieChartRendered() {
      this.pieChartRenderedCount++;
      // 如果两个饼图都渲染完成，则初始化柱状图
      if (this.pieChartRenderedCount === 1) {
        this.initBarData();
      }
    },
    handleBarChartRendered() {
      this.barChartRenderedCount++;
      // 如果两个柱状图都渲染完成，则初始化旭日图
      if (this.barChartRenderedCount === 1) {
        this.initSunburstData();
      }
    },
    // 初始化树状图数据
    initTreeData() {
      return speciesWithNumericalValue().then((res) => {
        setTimeout(() => {
          this.treeData = res.data;
        }, 500);
      });
    },
    // 初始化饼图数据
    initPieData() {
      return tfCountsByFamily().then((res) => {
        const pieData = res.data.map((pieData) => {
          pieData = pieData.map((item) => {
            item.value = Number(item.value);
            return item;
          });
          return pieData;
        });
        setTimeout(() => {
          this.pieData = pieData.map((item) => {
            const sum = item.reduce((a, b) => a + b.value, 0);
            item.push({
              value: sum,
              itemStyle: {
                color: "none",
                decal: {
                  symbol: "none",
                },
              },
              label: {
                show: false,
              },
            });
            return item;
          });
        });
      });
    },
    // 初始化柱状图数据
    initBarData() {
      const species = encodeURIComponent(this.speciesValue);
      return tfCountsBySpecies(species)
        .then((res) => {
          setTimeout(() => {
            if (res.data[0]) {
              this.xAxis = res.data[0];
            } else {
              this.xAxis = [];
            }
            if (res.data[1]) {
              this.barData = res.data[1];
            } else {
              this.barData = [];
            }
          });
        })
        .catch(() => {
          this.xAxis = [];
          this.barData = [];
        });
    },
    // 初始化旭日图数据
    initSunburstData() {
      return numericalValueByFamily().then((res) => {
        function recursion(item) {
          item.label = {
            rotate: "tangential",
            fontSize: px2rem(10),
          };
          if (item.children) {
            item.children = item.children.map((itemChild) => {
              return recursion(itemChild);
            });
          }
          return item;
        }

        setTimeout(() => {
          this.sunburstData = res.data.map((item) => {
            return recursion(item);
          });
        });
      });
    },
    handleTabClick() {
      if (this.activeName !== "Species") {
        this.$router.push({
          name: this.activeName,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.species {
  padding-bottom: px2rem(100);

  .species-banner {
    display: flex;
    align-items: center;
    height: px2rem(300);
    background-image: url("~@/assets/species/banner.webp");
    background-size: cover;
    background-position: bottom center;

    .species-banner__title {
      color: #fff;
    }
  }

  .species-body {
    padding-top: px2rem(30);
  }

  .species-tabs {
    margin-bottom: px2rem(80);
  }

  .species-panel {
    border: 1px solid #eee;
    padding: px2rem(30);
    margin-bottom: px2rem(30);
  }

  .species-title {
    font-size: px2rem(20);
    margin-bottom: px2rem(20);
  }

  .species-title__second {
    font-size: px2rem(16);
    margin-bottom: px2rem(20);
  }

  .species-title__third {
    font-size: px2rem(14);
    margin-top: px2rem(20);
    margin-bottom: px2rem(20);
  }

  .species-desc {
    font-size: px2rem(14);
    color: $--color-text-regular;
    margin-bottom: px2rem(40);
    line-height: 1.5;
  }

  .species-charts {
    margin-top: px2rem(40);
    height: px2rem(500);
    display: flex;

    &.tree-chart {
      height: px2rem(800);
    }
  }

  .species-charts__item {
    display: flex;
    flex: 1;
    height: 100%;

    &:nth-child(2n + 1) {
      margin-right: px2rem(10);
    }

    &:nth-child(2n) {
      margin-left: px2rem(10);
    }

    &.flex-column {
      flex-direction: column;
    }

    .species-charts__item__chart {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1;
      height: 100%;

      .species-charts__title {
        font-size: px2rem(14);
        font-weight: bold;
        margin-bottom: 0;
      }
    }
  }

  .species-charts__title {
    font-size: px2rem(16);
    font-weight: normal;
    margin-bottom: px2rem(30);
  }
}

::v-deep .el-tabs__header {
  margin: 0;
}

::v-deep .el-tabs__content {
  border: 1px solid #e4e7ed;
  border-top: none;
  padding: px2rem(30);
}
</style>
